var projects = [
  {
    id: 14,
    title: 'LOCATION VELO',
    type: 'website',
    urldisplay: 'velo-batz',
    outsidelink: 'http://velobatz.chez.com/',
    titlelink: 'Location de vélo à\'Ile de Batz.',
    imgalt: 'webdesign location velo batz',
    thumbsrc: 'site5.png',
    imgsrc: 's5.png',
    width: '1200',
    color1: '#557cfe',
    color2: '#3fd3e7',
    tags: ['Webdesign', 'Site Vitrine', '2020'],
    colors: ['#ffffff', '#3fd3e7', '#557cfe', '#dadde1', '#9bcffe', '#f8eac5', '#404145'],
    resume: 'Service de location de vélo sur l\'Ile de Batz pour une durée allant d\'une heure à une semaine.'
  },
  {
    id: 15,
    title: 'GROUPE OCEANIC',
    type: 'website',
    urldisplay: 'groupe-oceanic',
    outsidelink: 'https://www.groupeoceanic.fr',
    titlelink: 'Leader de la Promotion immobilière en Guyane',
    imgalt: 'webdesign promoteur immobilier Brest',
    thumbsrc: 'site6.png',
    imgsrc: 's6.png',
    width: '1200',
    color1: '#002c55',
    color2: '#003c6e',
    tags: ['Webdesign', 'Site Vitrine', '2019'],
    colors: ['#ffffff', '#f4cc42', '#d9b600', '#003c6e', '#002c55', '#7f97aa'],
    resume: 'Promoteur immobilier en Guyane et en Métropole, produit d\'investissement immobilier sur mesure, conseils en défiscalisation.'
  },
  {
    id: 0,
    title: 'OUEST BAT',
    type: 'website',
    urldisplay: 'ouest-bat',
    outsidelink: 'http://ouestbat.fr/',
    titlelink: 'ouest bat, entreprise de maçonnerie générale et gros-oeuvre à briec, engin yildirim',
    imgalt: 'webdesign ouest bat',
    thumbsrc: 'site1.png',
    imgsrc: 's1.png',
    width: '1200',
    color1: '#039cff',
    color2: '#0048cb',
    tags: ['Webdesign', 'Site Vitrine', '2017'],
    colors: ['#010f27', '#001e52', '#004cce', '#029cff', '#3187eb', '#ffffff'],
    resume: 'Entreprise générale de bâtiment située à Briec dans le département du Finistère (29). Créée en 2007 par Mr. Engin Yildirim, elle s\'est forgée une solide expérience dans le secteur de la construction et du gros-oeuvre.'
  },
  {
    id: 1,
    title: 'ENDORFINE BETA',
    type: 'website',
    urldisplay: 'endorfine-beta',
    outsidelink: 'http://dev.endorfine.fr/beta/',
    titlelink: 'Version 2016 du folio de kevin le saout',
    imgalt: 'webdesign endorfine',
    thumbsrc: 'site2.png',
    imgsrc: 's2.png',
    width: '1200',
    color1: '#ca292c',
    color2: '#6c1768',
    tags: ['Webdesign', 'Site Vitrine', '2016'],
    colors: ['#171715', '#2d2d2a', '#b52537', '#861b26', '#6c1768', '#482e58'],
    resume: 'Premier concept design de mon site personnel, qui avait pour objectif d\'afficher mes compétences, quelques informations personnelles ainsi que mes projets en cours.'
  },
  {
    id: 2,
    title: 'TRANSPORTS BOZEC',
    type: 'website',
    urldisplay: 'transport-bozec',
    outsidelink: 'http://www.transports-bozec.fr/',
    titlelink: 'Transport Bozec, société de transports routier de marchandise et de logistique à briec',
    imgalt: 'webdesign bozec',
    thumbsrc: 'site3.png',
    imgsrc: 's3.png',
    width: '1200',
    color1: '#0059d7',
    color2: '#19a9e9',
    tags: ['Webdesign', 'Site Vitrine', '2017'],
    colors: ['#ffffff', '#19a9e9', '#0059d7', '#ff6b02', '#ffb700', '#b4b4b4'],
    resume: 'Société de transport routier de marchandises et de logistique située à Briec dans le Finistère (29), transport de lots complets ou partiels en régional ou national (température dirigée et industriels).'
  },
  {
    id: 3,
    title: 'GLAZIK SOUNDBALL',
    type: 'website',
    urldisplay: 'glazik-soundball',
    outsidelink: 'http://dev.endorfine.fr/gsb/',
    titlelink: 'Tournois de balles aux prisonniers à briec organisé par l\'association Kamarad',
    imgalt: 'webdesign glazik soundball',
    thumbsrc: 'site4.png',
    imgsrc: 's4.png',
    width: '1200',
    color1: '#717c88',
    color2: '#2d3237',
    tags: ['Webdesign', 'Site Vitrine', '2016'],
    colors: ['#ffd504', '#2d3237', '#57595e', '#98999a', '#bfc1c2', '#ffffff'],
    resume: 'le GSB c\'est un tournoi de balles aux prisonniers 100% déguisé l\'après-midi et un concert avec plusieurs groupes et artistes en soirée'
  },
  {
    id: 16,
    title: 'RETRO GALATIC',
    type: 'logo',
    urldisplay: 'retro-galactic',
    outsidelink: 'http://fav.me/ddhuxuo',
    titlelink: 'lien vers le projet sur deviantart',
    imgalt: 'illustration retro galatic',
    thumbsrc: 'work5.png',
    imgsrc: 'w5.png',
    width: '1400',
    color1: '#14041c',
    color2: '#36287e',
    tags: ['Illustration', 'vectoriel', '2020'],
    colors: ['#c23fc2', '#fffd02', '#14041c', '#25083e', '#3c4bb4', '#0bdcff', '#ffffff'],
    resume: 'Illustration surfant sur les codes rétro-futuriste des années 80, les petites références à l\'univers Star Wars se mélangent sans difficulté avec ce paysage.'
  },
  {
    id: 17,
    title: 'ISOMETRIC TRAFFIC',
    type: 'logo',
    urldisplay: 'isometric-traffic',
    outsidelink: 'http://fav.me/dbatyon',
    titlelink: 'lien vers le projet sur deviantart',
    imgalt: 'illustration isometric traffic',
    thumbsrc: 'work6.png',
    imgsrc: 'w6.png',
    width: '1400',
    color1: '#644e4d',
    color2: '#4f3d45',
    tags: ['Illustration', 'Isometric', '2018'],
    colors: ['#b5b469', '#696c42', '#e6cec3', '#c1b7b7', '#5ea5a1', '#cd4e56', '#685e65'],
    resume: 'Illustration réalisée en 3D isométrique sur le thème de la circulation routière, cette image est ma toute première création dans ce style bien particulier.'
  },
  {
    id: 7,
    title: 'POLAR BEAR',
    type: 'logo',
    urldisplay: 'polar-bear',
    outsidelink: 'http://fav.me/db4qlyl',
    titlelink: 'lien vers le projet sur deviantart',
    imgalt: 'illustration polar bear',
    thumbsrc: 'work4.png',
    imgsrc: 'w4.png',
    width: '1400',
    color1: '#191e5c',
    color2: '#305fb1',
    tags: ['Illustration', 'Flat Design', '2017'],
    colors: ['#ea3870', '#e0ebf9', '#92bcfa', '#5a89d5', '#305fb1', '#191e5c'],
    resume: 'Illustration réalisée sur le thème du réchauffement climatique, polar bear représente un ours polaire qui subi malgré lui la fonte des glaces et la destruction de son habitat naturel'
  },
  {
    id: 4,
    title: 'LES KAMARAD',
    type: 'logo',
    urldisplay: 'les-kamarad',
    outsidelink: 'https://fb.com/leskamarad/',
    titlelink: 'facebook de l\'association les kamarad',
    imgalt: 'logo les kamarad',
    thumbsrc: 'work1.png',
    imgsrc: 'w1.png',
    width: '1400',
    color1: '#f6dc22',
    color2: '#e6b617',
    tags: ['Logotype', 'Charte Graphique', '2015'],
    colors: ['#2a0f00', '#e6b617', '#f6dc22', '#d02322', '#668c1d'],
    resume: 'Association culturelle et sportive créée dans le but de dynamiser le pays Glazik et rassembler les générations à travers des événements festifs et décalés'
  },
  {
    id: 5,
    title: 'PAOTRED BRIEC',
    type: 'logo',
    urldisplay: 'paotred-briec',
    outsidelink: 'http://fav.me/d8yis4w',
    titlelink: 'L\'équipe de foot briecoise, créer en 1928',
    imgalt: 'logo paotred briec',
    thumbsrc: 'work2.png',
    imgsrc: 'w2.png',
    width: '1400',
    color1: '#c1062b',
    color2: '#110003',
    tags: ['Logotype', 'Eblème', 'Éccusson', '2014'],
    colors: ['#110003', '#35343e', '#ffffff', '#f1ea9d', '#775524', '#c1062b'],
    resume: 'Paotred Briec est un club de foot qui évolue en championnat district, son école de foot forment les jeunes footballeurs du canton de Briec, Edern, Landrévarzec, Landudal, Langolen'
  },
  {
    id: 6,
    title: 'WEST RAMONAGE',
    type: 'logo',
    urldisplay: 'west-ramonage',
    outsidelink: 'http://dev.endorfine.fr/west/',
    titlelink: 'entreprise de ramonage sur le pays glazik, jimmy costard',
    imgalt: 'logo west ramonage',
    thumbsrc: 'work3.png',
    imgsrc: 'w3.png',
    width: '1400',
    color1: '#2f3640',
    color2: '#0c0c1c',
    tags: ['Logotype', 'Charte Graphique', '2015'],
    colors: ['#de0416', '#f24e24', '#fcfc2b', '#0c0c1c', '#2f3640', '#ffffff'],
    resume: 'Entreprise qui propose des solutions de chauffage au bois, poêle à bois et poêle à granulés, instalation, renovation et entretien'
  },
  {
    id: 8,
    title: 'EVENT ADVERT #1',
    type: 'poster',
    urldisplay: 'event-advert-1',
    outsidelink: 'http://fav.me/db5plzu',
    titlelink: 'lien vers le projet sur deviantart',
    imgalt: 'advert #1, template event 2017',
    thumbsrc: 'event1.png',
    imgsrc: 'e1.png',
    width: '740',
    color1: '#3e4f5d',
    color2: '#4ea8a5',
    tags: ['Événementiel', 'Géométric Design', '2017'],
    colors: ['#212129', '#3e4f5d', '#4ea8a5', '#d0e2e3', '#f3e593', '#5b594d'],
    resume: 'Affiche, Flyer pour une soirée ou un événement, disponible au téléchargement sur la plateforme Deviantart gratuitement sous license Creative Commons Attribution-Noncommercial-No Derivative Works 3.0 License.'
  },
  {
    id: 9,
    title: 'EVENT ADVERT #2',
    type: 'poster',
    urldisplay: 'event-advert-2',
    outsidelink: 'http://fav.me/db5kvju',
    titlelink: 'lien vers le projet sur deviantart',
    imgalt: 'advert #2, template event 2017',
    thumbsrc: 'event2.png',
    imgsrc: 'e2.png',
    width: '740',
    color1: '#660de8',
    color2: '#dc5cbd',
    tags: ['Événementiel', 'Géométric Design', '2017'],
    colors: ['#dc5cbd', '#d4e37a', '#39d28c', '#ffffff', '#660de8', '#3e07de'],
    resume: 'Affiche, Flyer pour une soirée ou un événement, disponible au téléchargement sur la plateforme Deviantart gratuitement sous license Creative Commons Attribution-Noncommercial-No Derivative Works 3.0 License.'
  },
  {
    id: 10,
    title: 'EVENT ADVERT #3',
    type: 'poster',
    urldisplay: 'event-advert-3',
    outsidelink: 'http://fav.me/dbcso05',
    titlelink: 'lien vers le projet sur deviantart',
    imgalt: 'GSB #5 event dodgeball, concert',
    thumbsrc: 'event3.png',
    imgsrc: 'e3.png',
    width: '740',
    color1: '#625179',
    color2: '#191c24',
    tags: ['Événementiel', 'Tournois', 'Concert', '2017'],
    colors: ['#0d0f0d', '#a9dbe9', '#8d97fe', '#fef02d', '#fb9808', '#7358a9'],
    resume: 'Affiche officiel du tournoi de balles aux prisonniers et de palet breton 5ème édition, suivis d\'un concert en soirée à la salle Arthémuse pour la fête de la musique. L\'événement était organisé par l\'asso les kamarad en partenariat avec la ville de Briec'
  },
  {
    id: 11,
    title: 'POSTER JUNGLE',
    type: 'poster',
    urldisplay: 'poster-jungle',
    outsidelink: 'http://fav.me/db5o3p8',
    titlelink: 'lien vers le projet sur deviantart',
    imgalt: 'poster #1, jungle plane wreck',
    thumbsrc: 'poster1.png',
    imgsrc: 'p1.png',
    width: '740',
    color1: '#5c7056',
    color2: '#121413',
    tags: ['Affiche', 'Flat Design', '2017'],
    colors: ['#121413', '#656b59', '#c0c794', '#deebdc', '#395036', '#808675'],
    resume: 'Affiche représentant la jungle d\'amérique du sud et la région ou vivait la civilisation Maya, Guatemala, et Copán au Honduras'
  },
  {
    id: 12,
    title: 'POSTER DUBAI',
    type: 'poster',
    urldisplay: 'poster-kayak',
    outsidelink: 'http://fav.me/db7ckvh',
    titlelink: 'lien vers le projet sur deviantart',
    imgalt: 'poster #2, dubai kayak',
    thumbsrc: 'poster2.png',
    imgsrc: 'p2.png',
    width: '740',
    color1: '#67a5f2',
    color2: '#81e6f8',
    tags: ['Affiche', 'Flat Design', '2016'],
    colors: ['#fa674e', '#3d3952', '#f8e9df', '#6ce0f6', '#39aec7', '#67a5f2'],
    resume: 'Affiche réalisée à partir d\'une photo postée sur reddit.com, prise sur un kayak depuis le rivage de dubai, on distingue au loin le burj khalifa.'
  },
  {
    id: 13,
    title: 'POSTER PYRAMYD',
    type: 'poster',
    urldisplay: 'poster-pyramyd',
    outsidelink: 'http://fav.me/d8qt2xm',
    titlelink: 'lien vers le projet sur deviantart',
    imgalt: 'poster #3, sunset pyramyd sand',
    thumbsrc: 'poster3.png',
    imgsrc: 'p3.png',
    width: '740',
    color1: '#cc1948',
    color2: '#3d001e',
    tags: ['Affiche', 'Flat Design', '2015'],
    colors: ['#f8c467', '#0e0006', '#3d001e', '#ce1a49', '#fce3c9', '#da688c', '#b91659'],
    resume: 'Affiche représentant les grandes pyramides au couché du soleil, disponible au téléchargement sur la plateforme Deviantart gratuitement sous license Creative Commons Attribution-Noncommercial-No Derivative Works 3.0 License'
  }
]

export default projects



// WEBPACK FOOTER //
// ./src/projects.js